export default "__VITE_ASSET__Bje5d61Y__"